<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Kontak Detail {{ kontakDetail.detail.display_name }}</h1>
                <div class="section-header-breadcumb button">
                    <button @click="deleteKontak(id_kontak)" class="btn btn-icon icon-left btn-danger" style="margin-right:5px;"><i class="fas fa-trash"></i> Hapus Kontak</button>
                    <a href="javascript:" @click.prevent="goTo('/master/kontak/kontak-edit/'+id_kontak)" class="btn btn-icon icon-left btn-primary"><i class="far fa-edit"></i> Edit Kontak</a>
                </div>
            </div>
            <div class="section-body">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="card">
                            <div class="card-header">
                                <h4>Informasi Kontak</h4>
                            </div>
                            <div class="card-body">
                                <table class="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th style="width:50%;">
                                                Tipe Kontak  
                                            </th>
                                            <td>
                                                {{ kontakDetail.detail.tipe_kontak }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Nama Kontak
                                            </th>
                                            <td>
                                                {{ kontakDetail.detail.display_name }} 
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Email Kontak  
                                            </th>
                                            <td>
                                                {{ kontakDetail.detail.email }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="card">
                            <div class="card-header">
                                <h4>Detail Kontak</h4>
                            </div>
                            <div class="card-body">
                                <table class="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th style="width:50%;">
                                                Nama Perusahaan 
                                            </th>
                                            <td>
                                                {{ kontakDetail.detail.company_name }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Nama Pemilik  
                                            </th>
                                            <td>
                                                {{ kontakDetail.detail.nama_pemilik }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Alamat Perusahaan 
                                            </th>
                                            <td>
                                                {{ kontakDetail.detail.alamat }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Nomor Telepon  
                                            </th>
                                            <td>
                                                {{ kontakDetail.detail.nomor_tlp }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4>History Transaksi Kontak</h4>
                            </div>
                            <div class="card-body">
                                <table class="table table-striped table-hover">
                                    <tr>
                                        <th>Deskripsi</th>
                                        <th>Tanggal</th>
                                        <th>Tipe</th>
                                    </tr>
                                    <tbody>
                                        <tr style="cursor:pointer;" v-for="(item,index) in kontakDetail.history" :key="item.id_history" @click="goDetailHistory(index)">
                                            <td>
                                                <span style="text-transform:capitalize;">{{ item.jenis_transaksi }}</span> Nomor Transaksi #{{ item.nomor_transaksi }}
                                            </td>
                                            <td>
                                                {{ item.created_at | moment("DD MMMM YYYY") }}
                                            </td>
                                            <td style="text-transform:capitalize;">
                                                &nbsp;
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <button @click="goBack()" class="btn btn-danger">Kembali</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            kontakDetail : {
                detail : {
                    tipe_kontak : '',
                }
            },
            id_kontak : '',
            back : ''
        }
    },
    mounted() {
        this.id_kontak = this.$route.params.id_kontak
        this.init();
    },
    methods: {
        init: function() {
            // get Kontak Detail
            this.$root.is_loading = !this.$root.is_loading;
			this.$http.post("Kontak/getKontakDetail/"+this.id_kontak).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get Detail')
                }
                else {
                    this.kontakDetail = result.data.detail
                    if(this.tipe_kontak == 'supplier'){
                        this.back = '/master/kontak-supplier'
                    }else {
                        this.back = '/master/kontak-pelanggan'
                    }
                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });
        },
        goBack: function() {
            this.$router.replace({ path : this.back })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        goDetailHistory(index) {
            if(this.kontakDetail.history[index].jenis_transaksi == 'pembelian') {
                this.$router.replace({ path : '/pembelian/transaksi-detail/'+this.kontakDetail.history[index].id_transaksi })
            }else if(this.kontakDetail.history[index].jenis_transaksi == 'penjualan') {
                this.$router.replace({ path : '/penjualan/transaksi-detail/'+this.kontakDetail.history[index].id_transaksi })
            }
        },
        deleteKontak: function() {
            if(!confirm('Kamu yakin mau menghapus kontak ini?')){
                return false
            }

            this.$root.is_loading = !this.$root.is_loading;
			this.$http.get("Kontak/deleteKontak/"+this.id_kontak).then(result => {
			    if(result.data.code == '00') {
                    alert('failed delete kontak')
                }
                else {
                    this.$parent.toastr = {
                        title : 'Success',
                        message : 'Success delete kontak !',
                        type : 'success'
                    }
                    this.$router.replace({ path : this.back })
                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.replace({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
    },
    
}
</script>


// WEBPACK FOOTER //
// src/components/kontak/KontakDetail.vue